import { BaseTheme } from "../../Themes/BaseTheme";
import { useEffect, useState } from "react";

export function useIsMobile() {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= BaseTheme.responsive.mobile);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= BaseTheme.responsive.mobile);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return isMobile;
}
